import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectToken } from "../redux/slices/userSlice";

const PrivateRoute = () => {
  const token = useSelector(selectToken); 

  if (!token) {
    return <Navigate to="/" replace />; 
  }

  return <Outlet />; 
};

export default PrivateRoute;
